import { type IAppointment } from '@principle-theorem/principle-core/interfaces';
import { type WithRef } from '@principle-theorem/shared';

export enum NewAppointmentSaveStatus {
  Saved = 'saved',
  Failed = 'failed',
}

export interface INewAppointmentSaved {
  status: NewAppointmentSaveStatus.Saved;
  appointment: WithRef<IAppointment>;
}

export interface INewAppointmentSaveFailed {
  status: NewAppointmentSaveStatus.Failed;
}

export type NewAppointmentSaveOutcome =
  | INewAppointmentSaved
  | INewAppointmentSaveFailed;
